<template>
	<div
		v-if="isReview"
		id="stamped-main-widget"
		:data-product-id="itemCode"
		:data-name="title"
		:data-url="url"
		:data-image-url="image"
		:data-description="description"
		:data-product-sku="sku"
	></div>
	<span v-else class="stamped-product-reviews-badge stamped-main-badge" :data-id="itemCode"></span>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'

import { useProductStore } from '@stores'

const props = defineProps({
	isReview: {
		type: Boolean,
		default: true,
	},
	product: {
		type: Object,
		required: true,
	},
})

const store = useProductStore()
const { selectedVariant } = storeToRefs(store)

const itemCode = computed(() => {
	if (props.product.hasVariants) {
		return selectedVariant.value?.id ?? props.product.itemId
	}
	return props.product.itemId
})
const title = computed(() => {
	if (props.product.hasVariants) {
		return `${props.product.title} - ${selectedVariant.value?.title}`
	}
	return props.product.title
})
const url = computed(() => window.location.href)
const image = computed(() => {
	if (props.product.hasVariants) {
		return selectedVariant.value?.images[0]?.src ?? props.product.currentItem.src
	}
	return props.product.currentItem.src
})
const description = computed(() => {
	if (props.product.hasVariants) {
		return selectedVariant.value?.descriptionHtml ?? props.product.currentItem.description
	}
	return props.product.currentItem.description
})
const sku = computed(() => {
	if (props.product.hasVariants) {
		return selectedVariant.value?.sku ?? props.product.sku
	}
	return props.product.sku
})

let scriptEl

onMounted(() => {
	scriptEl = document.createElement('script')
	scriptEl.src = 'https://cdn1.stamped.io/files/widget.min.js'
	scriptEl.async = true

	scriptEl.onload = () => {
		if (window.StampedFn) {
			window.StampedFn.init({
				apiKey: 'c7840bb8-ac6e-44e4-a93c-0cb5dde28b19',
				sId: '354176',
			})
		}
	}

	document.head.appendChild(scriptEl)
})

onBeforeUnmount(() => {
	if (scriptEl && scriptEl.parentNode) {
		scriptEl.parentNode.removeChild(scriptEl)
	}
})
</script>
